document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("faq-search");
  const searchButton = document.querySelector(".faq-search__submit");

  let firstMatch = null;

  function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function highlightAll(term, fullWordMatch = false) {
    const safeTerm = escapeRegex(term);
    const regex = fullWordMatch
    ? new RegExp(`([^\\s<>"']*${safeTerm}[^\\s<>"']*)`, "gi") // matches full words with umlauts
    : new RegExp(`(${safeTerm})`, "gi");

    const questions = document.querySelectorAll(".faq__question");
    const answers = document.querySelectorAll("[data-faq-answer]");
    const details = document.querySelectorAll("details.faq__item");

    firstMatch = null;

    const highlightText = (el) => {
      if (!el.dataset.original) {
        el.dataset.original = el.innerHTML;
      }

      if (term === "") {
        el.innerHTML = el.dataset.original;
      } else {
        const hasMatch = el.dataset.original.match(regex);
        el.innerHTML = el.dataset.original.replace(regex, "<mark>$1</mark>");
        if (hasMatch && !firstMatch) firstMatch = el;
      }
    };

    questions.forEach(highlightText);
    answers.forEach(highlightText);

    details.forEach((detail) => {
      const hasHighlight = detail.querySelector("mark");
      detail.open = !!hasHighlight;
    });
  }

  function scrollToFirstMatch() {
    if (firstMatch) {
      const target = firstMatch.closest("details, .faq__category") || firstMatch;
      setTimeout(() => {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
    }
  }

  // Only reset highlights on input
  input.addEventListener("input", function () {
    const term = input.value.trim();
    highlightAll(term, false); // partial highlight while typing (or none)
  });

  // On button click, do full word match + scroll
  searchButton?.addEventListener("click", function () {
    const term = input.value.trim();
    highlightAll(term, true); // full word match
    scrollToFirstMatch();
  });

  // On Enter press, do full word match + scroll
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      const term = input.value.trim();
      highlightAll(term, true); // full word match
      scrollToFirstMatch();
    }
  });
});